import { createIcon, IconColors } from './icon-utils';

export const ReportAddFilterIcon = createIcon({
  clipRule: 'evenodd',
  fill: IconColors.Primary,
  fillRule: 'evenodd',
  path: 'M12 21.188a9.188 9.188 0 1 1 0-18.376 9.188 9.188 0 0 1 0 18.375zm0-1.5a7.687 7.687 0 1 0 0-15.375 7.687 7.687 0 0 0 0 15.375zm-.75-11.063a.75.75 0 0 1 1.5 0v2.625h2.625a.75.75 0 0 1 0 1.5H12.75v2.625a.75.75 0 0 1-1.5 0V12.75H8.625a.75.75 0 0 1 0-1.5h2.625V8.625z',
});
